import {EventBus, Utils} from '../app.base';
import {MsgBox, Routes, Vue} from '../app.vues';
import {RouteLayerMgr} from '../compo/ctrl/RouteLayer';
//
import userApi from '../api/user';
import retailerApi from '../api/retailer';
import goodsCategApi from '../api/goodsCateg';
import assetNatureApi from '../api/assetNature';
//
let cachedFailFlagValue = -1;
//
//缓存当前用户上下文scopeEntity（-1：失败标记）
let cachedScopeEntity = null;
//缓存当前用户上下文权限资源信息（-1：失败标记）
let cachedUserPostRescMap = null;
//生成 url 层次片段
//minParts : 最小片段数
//toHierUrlPaths('/org/struct/com/main', 2) = > ["/org/struct/com/main","/org/struct/com","/org/struct"]
function toHierUrlPaths(url, minParts) {
    minParts = minParts || 1;
    //
    if (url.charAt(0) == '/') {
        url = url.substring(1);
    }
    //
    let pathParts = url.split('/')
    pathParts = pathParts.map(function (part) {
        return '/' + part;
    });
    //
    let retUrls = [];
    for (let i = pathParts.length; i >= minParts; i--) {
        retUrls.push(pathParts.join(''));
        pathParts.pop();
    }
    //
    if (retUrls.length == 0) {
        retUrls.push(pathParts.join(''))
    }
    //
    return retUrls
}

//获取并缓存当前用户上下文ScopeEntity信息
export function getUserScopeEntity() {
    if (cachedScopeEntity == null) {
        userApi.getUserInfoByContext({}, function (result) {
            if (result.type == 'info') {
                let userContext = result.data || {}
                let scopeEntity = userContext.scopeEntity || {}
                cachedScopeEntity = !scopeEntity.scopeCode ? cachedFailFlagValue : scopeEntity
            } else {
                cachedScopeEntity = cachedFailFlagValue
                //
                MsgBox.warning('获取用户组织信息失败')
            }
        })
    }
    //
    return cachedScopeEntity
}

let cachedRetailerComMap = {}

function getRetailerCom(id) {
    let comItem = cachedRetailerComMap[id]
    if (comItem == null) {
        let params = {
            comId: id
        }
        retailerApi.getRetailerCom(params, function (result) {
            if (result.type == 'info') {
                comItem = result.data
                if (!Utils.isNoB(comItem)) {
                    cachedRetailerComMap[comItem.id] = comItem
                }
            } else {
                MsgBox.warning('获取用户组织信息失败')
            }
        })
    }
    return comItem
}

//检查用户权限信息 aspectType : action, info, ...
function checkUserAspectPerm(compOrPath, aspectValue = null, aspectType = null, dataOwnerComId = null) {
    getUserScopeEntity()
    //
    if (cachedScopeEntity == null || cachedScopeEntity == cachedFailFlagValue) {
        return false
    }
    //
    if (cachedUserPostRescMap == null) {
        userApi.getUserPostRescListByContext({}, function (result) {
            if (result.type == 'info') {
                let userPostRescList = result.data || []
                //
                cachedUserPostRescMap = {}
                //
                userPostRescList.forEach(function (resc) {
                    if (resc.type === 0) {
                        //只处理hashUrl
                        //actions
                        let actionList = resc.actionList || null
                        if (actionList == null) {
                            if (resc.actions) {
                                actionList = resc.actions.split('|')
                            } else {
                                actionList = []
                            }
                            //
                            resc.actionList = actionList
                        }
                        //
                        resc.pattern = resc.pattern.trim()
                        //
                        cachedUserPostRescMap[resc.pattern] = resc
                    }
                })
            } else {
                cachedUserPostRescMap = cachedFailFlagValue
                //
                MsgBox.warning('获取权限信息失败')
            }
        })
    }
    //
    if (cachedUserPostRescMap == null || cachedUserPostRescMap == cachedFailFlagValue) {
        return false
    }
    //
    let hashUrl = compOrPath
    aspectType = aspectType || 'action'
    //
    if (compOrPath == null) {
        console.error('请指定要检查权限/操作的目标组件 或 path/url')
        //
        return false
    } else if (typeof compOrPath !== 'string') {
        if (compOrPath.authen === false) {
            return true
        }
        //
        hashUrl = compOrPath.fullPath || compOrPath.path
    }
    //
    if (hashUrl) {
        let resc = null
        let hierUrls = toHierUrlPaths(hashUrl, 2)
        for (let i = 0; i < hierUrls.length; i++) {
            resc = cachedUserPostRescMap[hierUrls[i]]
            if (resc != null) {
                console.log('匹配的权限资源：' + resc.pattern)
                break
            }
        }
        if (resc == null) {
            return false
        }
        //action
        if (aspectType == 'action' && aspectValue) {
            if (resc.actionList.indexOf(aspectValue) == -1) {
                return false
            }
        }
        let comEntity = Utils.merge({}, cachedScopeEntity)
        if (dataOwnerComId != null && dataOwnerComId != comEntity.comId && aspectValue) {
            let comItem = getRetailerCom(dataOwnerComId)
            if (comItem != null) {
                comEntity = Utils.merge({}, comItem)
            }
        }
        // 门店强制控制、其他控制当前不可操作，可以为下级操作
        if ((comEntity.shopFlag || dataOwnerComId != null) && aspectValue) {
            if (aspectType == 'action' && aspectValue) {
                let viewActionList = resc.viewActionList
                if (viewActionList != null && viewActionList.length > 0) {
                    if (viewActionList.indexOf(aspectValue) >= 0) {
                        return true
                    }
                }
            }
            // 是否受组织总体冻结状态控制
            if (comEntity.overallFrozen && resc.ucoOrgOverallFrozen) {
                return false
            }
            // 交易业务是否冻结
            if (comEntity.tradeBizFrozen && resc.ucoOrgTradeBizFrozen) {
                return false
            }
            // 设备业务是否冻结
            if (comEntity.devcBizFrozen && resc.ucoOrgDevcBizFrozen) {
                // 设备是否允许调出
                if (comEntity.devcAllotOutAllowed && resc.ucoOrgDevcAllotOutAllowed) {
                    return true
                }
                // 设备是否允许导入
                if (comEntity.devcImportAllowed && resc.ucoOrgDevcImportAllowed) {
                    return true
                }
                return false
            }
            // 资产业务是否冻结
            if (comEntity.assetBizFrozen && resc.ucoOrgAssetBizFrozen) {
                // 资产是否允许调出
                if (comEntity.assetAllotOutAllowed && resc.ucoOrgAssetAllotOutAllowed) {
                    return true
                }
                // 资产是否允许导入
                if (comEntity.assetImportAllowed && resc.ucoOrgAssetImportAllowed) {
                    return true
                }
                return false
            }
            // 维保业务是否冻结
            if (comEntity.maintBizFrozen && resc.ucoOrgMaintBizFrozen) {
                return false
            }
            // 财务业务是否冻结
            if (comEntity.fiscalBizFrozen && resc.ucoOrgFiscalBizFrozen) {
                return false
            }
            // 店务业务是否冻结
            if (comEntity.affairBizFrozen && resc.ucoOrgAffairBizFrozen) {
                return false
            }
            // 资产是否允许调出
            if (!comEntity.assetAllotOutAllowed && resc.ucoOrgAssetAllotOutAllowed) {
                return false
            }
            // 设备是否允许调出
            if (!comEntity.devcAllotOutAllowed && resc.ucoOrgDevcAllotOutAllowed) {
                return false
            }
            // 资产是否允许导入
            if (!comEntity.assetImportAllowed && resc.ucoOrgAssetImportAllowed) {
                return false
            }
            // 设备是否允许导入
            if (!comEntity.devcImportAllowed && resc.ucoOrgDevcImportAllowed) {
                return false
            }
        }
        //
        return true
    } else {
        console.error('要检查权限/操作的目标组件没有path信息 或 不是 path 或 不是组件')
        //
        return false
    }
}

//带二级缓存检查用户操作（可选的是否为指定岗位）权限
export function checkUserActionPermFor(compOrPath, action = null, targetPostId = null, dataOwnerComId = null) {
    //检查操作
    let result = checkUserAspectPerm(compOrPath, action, 'action', dataOwnerComId)
    //检查岗位是否为指定的岗位
    if (result === true && typeof targetPostId === 'number') {
        result = cachedScopeEntity.postId == targetPostId
    }
    //
    return result
}

//为路由添加全局权限拦截
export function setRouterPermGuard(router) {
    router.beforeEach(function (to, from, next) {
        let passed = true
        //
        let pathTo = to.path
        let pathFrom = from.path
        //
        console.log(pathFrom + '  =>  ' + pathTo)
        //
        let comp = Routes.get(pathTo)
        if (comp != null) {
            passed = checkUserActionPermFor(comp)
        }
        if (passed) {
            //路由弹层 切换
            RouteLayerMgr.setRoutePath(pathTo, true)
            //
            next()
        } else {
            if (comp.__file) {
                console.warn('未授权 资源对应组件 ：' + comp.__file)
            }
            //
            MsgBox.warning('目标资源未授权（"' + comp.desc + '"）')
            //
            next(false)
        }
    })
}

//
let global_userActionPermCache = {}
let checkActionPermCode = '        // 检查资源具体操作权限（可选的岗位id，数据所属公司id）\n' + '        checkActionPerm: function (action, targetPostId = null, dataOwnerComId = null) {\n' + '            let pathUrl = null;//默认自动获取当前组件类的path\n' + '            return checkUserActionPerm.call(this, pathUrl, action, targetPostId, dataOwnerComId);\n' + '        },'

//带一级缓存的基于上下文的资源、操作、数据权限检查
export function checkUserActionPerm(pathUrl = null, action = null, targetPostId = null, dataOwnerComId = null) {
    if (pathUrl == null) {
        console.error('无效的路径 path or url')
        //
        return false
    }
    let userActionPermCache = global_userActionPermCache
    //
    let cacheKey = pathUrl + '::' + (action == null ? '' : action) + '::' + (targetPostId == null ? '' : targetPostId) + '::' + (dataOwnerComId == null ? '' : dataOwnerComId)
    let cacheValue = userActionPermCache[cacheKey]
    if (cacheValue == null) {
        //原生调用
        cacheValue = checkUserActionPermFor(pathUrl, action, targetPostId, dataOwnerComId)
        userActionPermCache[cacheKey] = cacheValue
    } else {
        // console.log('got perm action info from cache');
    }
    return cacheValue
}

// 缓存[商户资产属性]
let cachedMerchtAssetNature = null;

export function cacheMerchtAssetNatureMap() {
    if (cachedMerchtAssetNature == null) {
        // null --> 默认上下文集团
        assetNatureApi.getMerchtAssetNatureListByRealId(null, (result) => {
            if (result.type == 'info') {
                let merchtAssetNatureList = result.data || [];
                let natureLength = merchtAssetNatureList.length;
                let assetNature = {};
                if (natureLength > 0) {
                    assetNature = merchtAssetNatureList.reduce((map, item) => {
                        let {sysAssetNature, sysAssetNatureName} = item;
                        if (!map[sysAssetNature]) {
                            map[sysAssetNature] = {
                                value: sysAssetNature, text: sysAssetNatureName
                            };
                        }
                        return map;
                    }, {});
                }
                // 转换为数组  [{value:1,text:"固定资产"},{value:22,text:"低值易耗"}]
                var resultArray = Object.keys(assetNature).map(function (key) {
                    return assetNature[key];
                });
                //
                cachedMerchtAssetNature = resultArray;
            } else {
                cachedMerchtAssetNature = {};

                MsgBox.warning('商户资产属性获取失败');
            }
            console.log('商户资产属性' + JSON.stringify(cachedMerchtAssetNature));
        });
    }
}

export function getMerchtAssetNatureMap(callback) {
    if (cachedMerchtAssetNature == null) {
        cacheMerchtAssetNatureMap();
    }
    //
    callback(cachedMerchtAssetNature);
}

//缓存当前商户商品分类设备分组
let cachedGoodsCatDevcGroupMap = null;

// 获取分类设备分组map
export function cacheGoodsCatDevcGroupMap() {
    //
    if (cachedGoodsCatDevcGroupMap == null) {
        goodsCategApi.getGoodsCatDevcGroupListForSync({}, function (result) {
            if (result.type == 'info') {
                let goodsCatDevcGroupList = result.data || []
                //
                cachedGoodsCatDevcGroupMap = {}
                //
                cachedGoodsCatDevcGroupMap = goodsCatDevcGroupList.toMap('catId')
            } else {
                cachedGoodsCatDevcGroupMap = cachedFailFlagValue
                //
                MsgBox.warning('获取权限信息失败')
            }
        })
    }
    //
    if (cachedGoodsCatDevcGroupMap == null || cachedGoodsCatDevcGroupMap == cachedFailFlagValue) {
        return false
    }
}

// 根据catId获取商品分类设备分组信息
export function getDevcGroupByCatId(catId = null) {
    //
    if (cachedGoodsCatDevcGroupMap == null || cachedGoodsCatDevcGroupMap == cachedFailFlagValue) {
        cacheGoodsCatDevcGroupMap();
    }
    return cachedGoodsCatDevcGroupMap[catId];
}

// 根据catId获取商品分类设备分组名称
export function getDevcGroupNameByCatId(catId = null) {
    //
    let devcGroup = getDevcGroupByCatId(catId)
    return devcGroup != null ? devcGroup.groupName : null
}

export function getUserRescByUrl(url = null) {
    let resc = null
    if (cachedUserPostRescMap == null) {
        checkUserActionPermFor('/')
    }
    if (cachedUserPostRescMap != null) {
        resc = cachedUserPostRescMap[url]
    }
    return resc
}

let EB = EventBus.get('sidebar')

// name ：面包屑名称， parentBreadcrumbUrl ：所属一级url
export function syncSetBreadcrumb(name, parentBreadcrumbUrl) {
    let breadcrumb = {
        name: name, parentBreadcrumbUrl: parentBreadcrumbUrl
    }
    setTimeout(function () {
        EB.trigger('sidebar:syncSetBreadcrumbList', breadcrumb)
    }, 500)
}

// 当前频道
let thisSysMenuChnl = null

export function syncSysMenuChnl(sysMenuChnl) {
    thisSysMenuChnl = sysMenuChnl
}

export function getThisSysMenuChnl() {
    if (thisSysMenuChnl != null && thisSysMenuChnl.id != null) {
        return thisSysMenuChnl
    } else {
        return null
    }
}

export function isSysRescFrozenIsAllowed(self, comInfo) {

    let urlInfo = Utils.parseUrl(window.location.href)
    let hashInfo = Utils.parseUrl(urlInfo.hash, true)
    let compOrPath = hashInfo.uri
    if (hashInfo.params != null && hashInfo.params.parentPath != null) {
        compOrPath = hashInfo.params.parentPath
    }
    console.log('加载的url' + compOrPath)
    return checkOrgComAspectPerm(compOrPath, comInfo)
}

// 检查选择的机构是否冻结可操作
function checkOrgComAspectPerm(compOrPath, comInfo) {
    //
    if (comInfo == null) {
        getUserScopeEntity()
        //
        if (cachedScopeEntity == null || cachedScopeEntity == cachedFailFlagValue) {
            return false
        }
        comInfo = cachedScopeEntity
    } else {
        if (comInfo.name == null) {
            comInfo = getRetailerCom(comInfo.id)
        }
    }
    if (comInfo == null) {
        return true
    }
    //
    if (cachedUserPostRescMap == null) {
        userApi.getUserPostRescListByContext({}, function (result) {
            if (result.type == 'info') {
                let userPostRescList = result.data || []
                //
                cachedUserPostRescMap = {}
                //
                userPostRescList.forEach(function (resc) {
                    if (resc.type === 0) {
                        //
                        resc.pattern = resc.pattern.trim()
                        //
                        cachedUserPostRescMap[resc.pattern] = resc
                    }
                })
            } else {
                cachedUserPostRescMap = cachedFailFlagValue
                //
                MsgBox.warning('获取权限信息失败')
            }
        })
    }
    //
    if (cachedUserPostRescMap == null || cachedUserPostRescMap == cachedFailFlagValue) {
        return false
    }
    //
    let hashUrl = compOrPath
    //
    if (compOrPath == null) {
        console.error('请指定要检查权限/操作的目标组件 或 path/url')
        //
        return false
    } else if (typeof compOrPath !== 'string') {
        if (compOrPath.authen === false) {
            return true
        }
        //
        hashUrl = compOrPath.fullPath || compOrPath.path
    }
    //
    if (hashUrl) {
        let resc = null
        let hierUrls = toHierUrlPaths(hashUrl, 2)
        for (let i = 0; i < hierUrls.length; i++) {
            resc = cachedUserPostRescMap[hierUrls[i]]
            if (resc != null) {
                console.log('匹配的权限资源：' + resc.pattern)
                break
            }
        }
        if (resc == null) {
            return true
        }
        // 门店强制控制、其他控制当前不可操作，可以为下级操作

        // 是否受组织总体冻结状态控制
        if (comInfo.overallFrozen && resc.ucoOrgOverallFrozen) {
            return false
        }
        // 交易业务是否冻结
        if (comInfo.tradeBizFrozen && resc.ucoOrgTradeBizFrozen) {
            return false
        }
        // 设备业务是否冻结
        if (comInfo.devcBizFrozen && resc.ucoOrgDevcBizFrozen) {
            // 设备是否允许调出
            if (comInfo.devcAllotOutAllowed && resc.ucoOrgDevcAllotOutAllowed) {
                return true
            }
            // 设备是否允许导入
            if (comInfo.devcImportAllowed && resc.ucoOrgDevcImportAllowed) {
                return true
            }
            return false
        }
        // 资产业务是否冻结
        if (comInfo.assetBizFrozen && resc.ucoOrgAssetBizFrozen) {
            // 资产是否允许调出
            if (comInfo.assetAllotOutAllowed && resc.ucoOrgAssetAllotOutAllowed) {
                return true
            }
            // 资产是否允许导入
            if (comInfo.assetImportAllowed && resc.ucoOrgAssetImportAllowed) {
                return true
            }
            return false
        }
        // 维保业务是否冻结
        if (comInfo.maintBizFrozen && resc.ucoOrgMaintBizFrozen) {
            return false
        }
        // 财务业务是否冻结
        if (comInfo.fiscalBizFrozen && resc.ucoOrgFiscalBizFrozen) {
            return false
        }
        // 店务业务是否冻结
        if (comInfo.affairBizFrozen && resc.ucoOrgAffairBizFrozen) {
            return false
        }
        // 资产是否允许调出
        if (!comInfo.assetAllotOutAllowed && resc.ucoOrgAssetAllotOutAllowed) {
            return false
        }
        // 设备是否允许调出
        if (!comInfo.devcAllotOutAllowed && resc.ucoOrgDevcAllotOutAllowed) {
            return false
        }
        // 资产是否允许导入
        if (!comInfo.assetImportAllowed && resc.ucoOrgAssetImportAllowed) {
            return false
        }
        // 设备是否允许导入
        if (!comInfo.devcImportAllowed && resc.ucoOrgDevcImportAllowed) {
            return false
        }
        //
        return true
    } else {
        //
        return false
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/index.js
// module id = 4
// module chunks = 0